import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import swal from 'sweetalert2';
import { isUndefined } from 'util';
import { AdminService } from '../../layout/modules/admin/services/admin/admin.service';
import { StudyDocumentService } from '../../layout/modules/admin/services/study-document/study-document.service';
import { EventService } from '../../services/event/event.service';
import { HelperService } from '../../services/helper/helper.service';
import { UiService } from '../../services/ui/ui.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
  providers: [StudyDocumentService],
})
export class FileUploadComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('fileInputBtn') public fileInputBtn: ElementRef;

  @Input() parentId = null;
  @Input() type:
    | 'course'
    | 'studyDoc'
    | 'exam'
    | 'rlp'
    | 'resources'
    | 'eafs'
    | 'eafsExam' = null;
  @Input() emba = 0;
  @Input() files = [];
  @Input() uniqueId = Date.now();
  @Input() buttonName = 'Upload Material';
  @Input() buttonPlacement = 'bottom';
  @Input() buttonHidden = false;
  @Input() fullPage = false;
  @Input() deletedFileIds = [];

  @Input() addApi = null;
  @Input() updateApi = null;
  @Input() deleteApi = null;

  @Output() filesChange = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() deletedFileIdsChange = new EventEmitter();
  @Output() loadingStart = new EventEmitter();
  @Output() loadingEnd = new EventEmitter();

  public materialType = [
    { name: 'Slides', title: 'Slides', data: [] },
    { name: 'Cases', title: 'Cases', data: [] },
    { name: 'Additional readings', title: 'Additional readings', data: [] },
    {
      name: 'Other course matterials',
      title: 'Other course materials',
      data: [],
    },
    { name: 'Syllabus', title: 'Syllabus', data: [] },
  ];

  constructor(
    public adminService: AdminService,
    public ui: UiService,
    private studyDocService: StudyDocumentService,
    public helper: HelperService,
    public event: EventService
  ) {}

  ngOnInit() {
    this.setEvents();
  }

  ngOnChanges(changes: SimpleChanges) {
    const { files } = changes;
    if (
      files &&
      files.currentValue.find(
        (file) =>
          isUndefined(file.title) ||
          isUndefined(file.comment) ||
          isUndefined(file.order)
      )
    ) {
      this.filesChange.emit(
        files.currentValue.map((file, index) => ({
          ...file,
          editable: false,
          title: file.title || file.name.split('.').slice(0, -1).join('.'),
          comment: file.comment || '',
          order: file.order || index + 1,
        }))
      );
    }
  }

  ngOnDestroy() {
    this.event.unsubscribe('file-upload');
  }

  private setEvents() {
    this.event.on('file-upload', 'FileUpload.initUpload', () => {
      this.fileInputBtn.nativeElement.click();
    });
  }

  addDocument(event) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      event.target.value = '';
      const newFile = {
        name: file.name,
        title: file.name.split('.').slice(0, -1).join('.'),
        comment: '',
        order:
          this.files.reduce(
            (maxOrder, data) => Math.max(maxOrder, data.order),
            0
          ) + 1,
        extension: file.name.split('.').slice(-1)[0],
        loading: true,
        type: '',
        showType: '',
        deleted: false,
        editable: false,
        ...(['course', 'eafs'].includes(this.type) ? { published: true } : {}),
      };
      const index = this.files.length;
      this.filesChange.emit([...this.files, newFile]);
      const apiList = {
        course: this.adminService.addCourseDocument.bind(this.adminService),
        studyDoc: this.studyDocService.addFile.bind(this.studyDocService),
        exam: this.adminService.addExamFile.bind(this.adminService),
        rlp: this.adminService.addRLPDocument.bind(this.adminService),
        diplomaPaper: this.adminService.addDiplomaPaperDocument.bind(
          this.adminService
        ),
        eafs: this.adminService.addEAFSDocument.bind(this.adminService),
        eafsExam: this.adminService.addEAFSExamFile.bind(this.adminService),
      };
      ((fileIndex, uniqueId) => {
        const api = this.addApi || apiList[this.type];
        const payload =
          this.type !== 'resources'
            ? file
            : {
                data: {
                  name: newFile.name,
                  title: newFile.title,
                  comment: newFile.comment,
                  order: newFile.order,
                  extension: newFile.extension,
                },
                file,
              };
        api(payload, (err, res) => {
          if (this.uniqueId !== uniqueId) {
            return;
          }
          if (err) {
            swal('Error!', err.file, 'warning');
            this.filesChange.emit(this.files.filter((_, i) => i !== fileIndex));
          } else {
            this.filesChange.emit(
              this.files.map((data, i) => {
                if (i === fileIndex) {
                  const newFileData = this.type === 'eafs' ? res : res.file;
                  data = { ...data, ...newFileData };
                  delete data.loading;
                }
                return data;
              })
            );
            // this.editFile(this.files[fileIndex], () => { });
          }
        });
      })(index, this.uniqueId);
    }
  }

  setFileName(title, file) {
    file.name = title + '.' + file.name.split('.').slice(-1)[0];
    file.title = title;
  }

  setEditable(index) {
    this.files[index].editable = true;
    setTimeout(() => {
      document.getElementById(this.uniqueId + '-input-' + index).focus();
    }, 0);
  }

  unsetEditable(index) {
    this.files[index].editable = false;
  }

  editFile(file, callback = null) {
    // console.log(file);
    if (['course'].includes(this.type)) {
      this.event.emit('openEditCourseMaterialModal', file);
    } else {
      const getValue = (id) => {
        const elem = <HTMLInputElement>document.getElementById(id);
        return elem && elem.value;
      };
      const { title, comment, order, path, extension } = file;
      swal({
        title: callback ? 'Add Resource' : 'Edit Resource',
        html: `
          <label for="edit-file-title">Name*</label>
          <input id="edit-file-title" class="swal2-input" value="${title}">
          ${
            !extension
              ? `
          <label for="edit-file-path">Link*</label>
          <input id="edit-file-path" class="swal2-input" value="${path}">
          `
              : ''
          }
          <label for="edit-file-comment">Comment</label>
          <textarea id="edit-file-comment" class="swal2-input" style="padding:0.75em;height:100px;">${comment}</textarea>
          <label for="edit-file-order">Order</label>
          <input type="number" id="edit-file-order" class="swal2-input" style="max-width:100%;width:100%;" value="${order}">
        `,
        focusConfirm: false,
        customClass: 'edit-file',
        showCancelButton: this.type === 'resources' ? true : false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        preConfirm: () => {
          const value = {
            title: getValue('edit-file-title'),
            comment: getValue('edit-file-comment'),
            order: getValue('edit-file-order'),
            path: getValue('edit-file-path'),
          };
          return new Promise((resolve, reject) => {
            if (!value.title) {
              reject('Name field is required');
            } else {
              resolve(value);
            }
          }).catch((err) => swal.showValidationError(err));
        },
      }).then(({ value }) => {
        if (value) {
          // console.log(value);
          const arr = value.order.match(/^[0-9]{1,}/);
          const {
            title: oldTitle,
            path: oldPath,
            comment: oldComment,
            order: oldOrder,
          } = file;
          file.title = value.title;
          // file.name = value.title + '.' + file.extension;
          file.comment = value.comment;
          file.order = arr ? Number(arr[0]) : 0;
          if (value.path) {
            file.path = value.path;
          }
          if (callback) {
            callback();
          } else {
            // console.log(file, this.updateApi);
            if (this.updateApi) {
              const { id, ...fileData } = file;
              this.ui.loader.show();
              this.updateApi(id, fileData, (err, res) => {
                this.ui.loader.hide();
                if (!err) {
                  this.filesChange.emit([].concat(this.files));
                } else {
                  file.title = oldTitle;
                  file.comment = oldComment;
                  file.order = oldOrder;
                  file.path = oldPath;
                  this.filesChange.emit([].concat(this.files));
                }
              });
            } else {
              this.filesChange.emit([].concat(this.files));
            }
          }
        }
      });
    }
  }

  deleteFile(file, fileIndex) {
    // this.filesChange.emit(
    //   this.files.map((F, i) => (i === fileIndex ? { ...F, deleted: true } : F))
    // );
    if (this.type === 'eafs') {
      this.filesChange.emit(
        this.files.map((data, i) =>
          i == fileIndex ? { ...data, deleted: !data.deleted } : data
        )
      );
      this.delete.emit(file);
      return;
    }
    this.loadingStart.emit();
    swal({
      title: 'Are you sure?',
      text: "Click 'Yes' to delete '" + (file.title || file.name) + "'",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#9a4856',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.value) {
        if (this.deleteApi) {
          file.loading = true;
          this.deleteApi(file.id, (err, res) => {
            file.loading = false;
            if (!err) {
              this.filesChange.emit(
                this.files.filter((data) => data.id !== file.id)
              );
            }
            this.loadingEnd.emit();
          });
        } else if (['course', 'eafs'].includes(this.type)) {
          file.deleted = true;
          if (file.id) {
            this.delete.emit(file);
            this.deletedFileIdsChange.emit([...this.deletedFileIds, file.id]);
          } else {
            this.filesChange.emit(this.files.filter((data) => !data.deleted));
          }
          this.loadingEnd.emit();
        } else {
          const newFileJson = this.files.filter(
            (F, i) => i !== fileIndex && !F.tmp_path && !file.deleted
          );
          if (this.parentId) {
            const payload = {
              id: this.parentId,
              documents: newFileJson,
              file: newFileJson,
              diploma_paper_files: newFileJson,
            };
            const apiList = {
              studyDoc: this.studyDocService.removeFile.bind(
                this.studyDocService
              ),
              exam: this.adminService.removeExamFile.bind(this.adminService),
              rlp: this.adminService.removeRLPDocument.bind(this.adminService),
              diplomaPaper: this.adminService.removeDiplomaPaperDocument.bind(
                this.adminService
              ),
              eafsExam: this.adminService.removeEAFSExamFile.bind(
                this.adminService
              ),
            };
            this.files[fileIndex].loading = true;
            apiList[this.type](this.files[fileIndex], payload, (err, res) => {
              this.files[fileIndex].loading = false;
              if (err) {
                this.helper.handleError(err, 'error');
              } else {
                this.filesChange.emit(
                  this.files.filter((_, i) => i !== fileIndex)
                );
                this.delete.emit();
              }
              this.loadingEnd.emit();
            });
          } else {
            this.filesChange.emit(this.files.filter((_, i) => i !== fileIndex));
            this.loadingEnd.emit();
          }
        }
      } else {
        this.loadingEnd.emit();
      }
    });
  }
}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/file-upload/file-upload.component.ts